import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild,
  SecurityContext} from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import {ConfigService} from '../../../services/config/config.service';
import {TableOfContentsService} from '../../../services/toc/table-of-contents.service';
import {NestedTreeControl} from '@angular/cdk/tree';
import {MatTreeNestedDataSource} from '@angular/material/tree';
import {AGSLayer} from '../../../models/AGSLayer';
import cloneDeep from 'lodash/cloneDeep';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {MapService} from '../../../services/map/map.service';
import {ChangelogDialogComponent} from './changelog-dialog/changelog-dialog.component';
import {DialogComponent} from '../../../components/dialog/dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {InitializeService} from '../../../services/initialize/initialize-service';
import { DomSanitizer, SafeHtml} from '@angular/platform-browser';
import {loadModules} from 'esri-loader';
//import {BookmarkService} from '../../../services/bookmark/bookmark.service';
import {GoogleAnalyticsService} from '../../../services/googleAnalytics/google-analytics.service';

/**
 * Creates the table of contents from the widget bar
 */
@Component({
  selector: 'app-table-of-contents',
  templateUrl: './table-of-contents.component.html',
  styleUrls: ['./table-of-contents.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableOfContentsComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('themeMenuTrigger', {read: MatMenuTrigger, static: true}) public themeMenuTrigger: MatMenuTrigger;
  constructor(private map: MapService, private config: ConfigService,
              private toc: TableOfContentsService, private cd: ChangeDetectorRef,
              private router: Router, private route: ActivatedRoute,
              private location: Location, private dialog: MatDialog,
              private initService: InitializeService,
              //private bookmark: BookmarkService,
              private sanitizer: DomSanitizer, private ga: GoogleAnalyticsService) {
    this.nestedTreeControl = new NestedTreeControl<any>(this.getChildren);
    this.nestedDataSource = new MatTreeNestedDataSource();
    //basemaps
    this.nestedBasemapControl = new NestedTreeControl<any>(this.getChildren);
    this.nestedBasemapSource = new MatTreeNestedDataSource();

    this.changelog = this.config.changelog;
  }

  public widgetTitle = 'Table of Contents';
  public widgetIcon = './assets/widget-bar/toc-icon.png';

  public hideThemeChangeButton = false;
  public TOC;
  public nestedTreeControl: NestedTreeControl<any>;
  public nestedDataSource: MatTreeNestedDataSource<any>;
  // basemaps
  public nestedBasemapControl: NestedTreeControl<any>;
  public nestedBasemapSource: MatTreeNestedDataSource<any>;
  private basemapArray;
  private basemapNodes;
  private TOCNodeArray: object[];
  public tagList: any = [];
  public tagFilter = '';
  public themeList = [];
  public currentTheme = '';
  private layerUpdatedObservable;
  private layerSvcCompleteObservable;
  private mapObservable;
  private basemapObservable;
  private urlUpdatedObservable;
  public mapScale: number;
  public changelog = false;
  public basemap;
  public mapRef;
  public themeHelpInfo = [];
  public htmlFileString;
  public layerNodeChanged;
  public sliderOn = false;
  public loading = false;
  private urlUpdatedObs;
  private themeClickObs;
  private layerLoadErrorObservable;
  private basemapVisible;

  /**
   * Initialize TOC widget
   */
  async ngOnInit() {
    if (this.toc.firstRunFlag) {
      for (const widget of this.config.tools) {
        if (widget.id === 'toc') {
          this.widgetIcon = widget.icon;
          this.widgetTitle = widget.name;
          break;
        }
      }
    }

    this.countThemesAndHideThemeChangeButton();

    /* this.urlUpdatedObservable = this.bookmark.getUrlUpdatedObs().subscribe( (result) => {
      console.log('in urlUpdated');
      this.cd.detectChanges();
    }); */

    this.themeClickObs = this.toc.getThemeClickObs().subscribe((themeName) => {
      if (themeName) {
        // const loading = document.querySelector('#loading-svg') as HTMLElement;
        // loading.style.visibility = 'unset';
        // this.nestedDataSource.data = null;
        // console.log(this.nestedDataSource);
        // console.log(this.nestedTreeControl);
        this.nestedTreeControl.collapseAll();
        // console.log(this.nestedTreeControl.dataNodes);
        // this.nestedTreeControl.expansionModel.clear();
        // this.toc.removeAllLayers();
        // if (this.nestedTreeControl.expansionModel.selected) {
        for (let i = 0; i < this.nestedTreeControl.expansionModel.selected.length; i++) {
          this.nestedTreeControl.expansionModel.selected[i].pop();
        }
        // }


        this.themeClick(themeName);
      }
      this.cd.detectChanges();
    });

    this.mapObservable = this.map.getMapScaleObservable().subscribe( (result) => {
      if (result) {
        this.mapScale = result;
        this.mapRef = this.map.getViewRef();
        this.cd.detectChanges();
      }
    });

      // Listen for basemap change
      // Set the basemap visibility for the app's initial basemap. The default is visible true but some apps wanted the
      // the basemaps not visible at startup. The config.mapInitialLayerVisible property allows that feature.
      this.basemapVisible = this.config.mapInitialLayerVisible;
      this.basemapObservable = this.map.getBasemapObservable()
      .subscribe((newBasemap:Object) => {
        if (newBasemap && this.basemapNodes && this.basemapNodes[0]) {
          // Set the properties for the new basemap on the TOC node.
          this.basemapNodes[0].id = newBasemap["title"];
          this.basemapNodes[0].name = newBasemap["title"];
          this.basemapNodes[0].nodeType = 'basemap';
          this.basemapNodes[0].description = null;
          this.basemapNodes[0].isChecked = this.basemapVisible;
          this.basemapClicked({checked: this.basemapVisible},this.basemapNodes[0]);
          // Basemap visibility is true unless set to false in the mapInitialLayerVisible property in the app config.
          // That property controls the app's initial basemap. After that any basemap turned on by the basemap
          // widget are visible by default.
           this.basemapVisible = true;
          this.cd.detectChanges();

          // Get the basemap description from the portalItem or sourceJSON property. If neither property exists use
          // the resourceInfo property to get the basemap url and get the description from the rest endpoint.

          // Set description from portalItem if exists
          if (newBasemap['portalItem'] && newBasemap['portalItem']['description'] &&
            newBasemap['portalItem']['description'].length > 0) {
            this.basemapNodes[0].description = newBasemap['portalItem']['description'];
          }
          this.basemapNodes[0].url = null;
          if (newBasemap['baseLayers'] && newBasemap['baseLayers'].items && newBasemap['baseLayers'].items[0]) {
            this.basemapNodes[0].baseLayer = newBasemap['baseLayers'].items[0];
            if (this.basemapNodes[0].baseLayer.sourceJSON && this.basemapNodes[0].baseLayer.sourceJSON.description) {
              // Set description from sourceJSON
              this.basemapNodes[0].description = this.basemapNodes[0].baseLayer.sourceJSON.description;
            }
            if (this.basemapNodes[0].baseLayer.url && this.basemapNodes[0].baseLayer.url.length > 0)  {
              this.basemapNodes[0].url = this.basemapNodes[0].baseLayer.url;
            }
            if (this.basemapNodes[0].baseLayer.opacity)  {
              this.basemapNodes[0].opacity = this.basemapNodes[0].baseLayer.opacity;
              this.basemapNodes[0].transparency = this.basemapNodes[0].baseLayer.opacity;
            }
          }
          else {
            // If no url for basemap, get it from the resourceInfo on the basemap. The url can be used to get the description.
            if (newBasemap['resourceInfo'] && newBasemap['resourceInfo'].data && newBasemap['resourceInfo'].data.baseMapLayers &&
              newBasemap['resourceInfo'].data.baseMapLayers[0]) {
                this.basemapNodes[0].url = newBasemap['resourceInfo'].data.baseMapLayers[0].url;
                this.basemapNodes[0].opacity = newBasemap['resourceInfo'].data.baseMapLayers[0].opacity
              }
          }
          this.cd.detectChanges();
        }
      });

    // Subscribe to layer checkbox clicks from other components so TOC checkboxes will also get updated.
    this.layerNodeChanged = this.toc.getLayerCheckBoxChanged().subscribe(
      (nodeLayerElem) => {
        if (nodeLayerElem) {
          this.cd.detectChanges();
        }
      }
    );

    // Subscribe to layer getlayerServiceInfoComplete to update min/max scales (if they exist in service) for default visible layers.
      // This is to enable the layer out-of-scale style if applicable
      this.layerSvcCompleteObservable = this.toc.getlayerServiceInfoComplete().subscribe(
        async (node) => {
          if (node && node.defaultThemeVisibleLayerArr && node.defaultThemeVisibleLayerArr.length > 0
            && ((node.minScale && node.minScale > 0) || (node.maxScale && node.maxScale > 0)) ){
            let svcLayerID = node.serviceLayerID;
            // Find layer in TOC nodes and update if applicable
              this.nestedDataSource.data.forEach( (layer) => {
                let nodesObj = layer.nodes;
                nodesObj.every( (layerNode ) => {
                  if (layerNode.serviceLayerID === svcLayerID) {
                    if (node.minScale && (!layerNode.minScale || layerNode.minscale > node.minScale)) {
                      layerNode.minScale = node.minScale;
                    }
                    if (node.maxScale && (!layerNode.maxScale || layerNode.maxScale < node.maxScale)) {
                      layerNode.maxScale = node.maxScale;
                    }
                    return false;
                  }
                  else {
                    return true;
                  }
                });
              });
            this.cd.detectChanges();
        }
    });

     // Subscribe to layerLoadError
     this.layerLoadErrorObservable = this.toc.layerLoadError.subscribe((layerElem) => {
        if (layerElem) {
          const nodeArrObj = {
              "nodeArr": this.TOCNodeArray};
          layerElem.layerAvailable = false;
          // Get the TOC layerElem object to set layerAvailable status
          const retNodes = this.toc.findObjectsByKey(nodeArrObj,'serviceLayerID', layerElem.serviceLayerID);
          if (retNodes && retNodes.length > 0) {
            for (var i = 0; i < retNodes.length; i++) {
              retNodes[i].layerAvailable = false;;
            }
          }
          console.log('Layer unavailable: ' + layerElem.serviceLayerID);
        }
        this.cd.detectChanges();
      });

    this.cd.detectChanges();

    // Subscribe to layer nodeArr updated
    this.initializeToC();
    this.cd.detectChanges();
  }

  /**
   * Destroy TOC widget
   */
  ngOnDestroy(): void {
    if (this.mapObservable) { this.mapObservable.unsubscribe(); }
    if (this.basemapObservable) { this.basemapObservable.unsubscribe(); }
    if (this.layerUpdatedObservable) { this.layerUpdatedObservable.unsubscribe(); }
    if (this.layerNodeChanged) { this.layerNodeChanged.unsubscribe(); }
    if (this.layerSvcCompleteObservable) { this.layerSvcCompleteObservable.unsubscribe(); }
    if (this.urlUpdatedObservable) { this.urlUpdatedObservable.unsubscribe(); }
    if (this.layerLoadErrorObservable) {this.layerLoadErrorObservable.unsubscribe() ;}
    if (this.themeClickObs) {this.themeClickObs.unsubscribe() ;}
  }

  ngAfterViewInit() {
    this.toc.themesMenuTrigger = this.themeMenuTrigger;
  }

  public openThemeMenu() {
    console.log('openThemeMenu');
    this.themeMenuTrigger.openMenu();
    this.cd.detectChanges();
  }

  /**
   * Initializes TOC
   * Sets up the TOC after checking to see if a user is authorized to view the requested data
   * Reads in the TOC nodearray file for the current theme and populates the TOC
   */
  private async initializeToC() {
    try {
      // Set the basemap visibility for the theme, some apps may turn it off on startup
      this.basemapVisible = true;
      if (this.config.mapInitialLayerVisible !== undefined &&
        this.config.mapInitialLayerVisible === false) {
        this.basemapVisible = this.config.mapInitialLayerVisible;
      }
      if (this.toc.firstRunFlag && this.config && this.config["appDisclaimer"]) {
          if (this.config["appDisclaimer"].fileName) {
            // app disclaimer is in a file
            const fileDisclaimerObj = {fileName: this.config["appDisclaimer"].fileName,
                  showDisclaimer: this.config["appDisclaimer"].showDisclaimer }
                await this.showDisclaimerFromFile(fileDisclaimerObj);
          }
          else {
            if (this.config["appDisclaimer"].text) {
              // app disclaimer is a text string
              this.showDisclaimer({"disclaimer": {"message": this.config["appDisclaimer"].text}});
            }
          }
      }
      if (!this.toc.firstRunFlag) {
        this.currentTheme = this.config.CurrentTheme;
        //console.log ('in toc-comp initializeToc: ' + this.currentTheme);
        const isUserAuthorized = await this.toc.getAuthorization(this.config);
        if (isUserAuthorized) {
          this.TOCNodeArray = this.config.tocNodeArray;
          this.toc.nodeArray = this.config.tocNodeArray;
          this.themeList = this.config.themeNameList;

          // Set up folder for Basemaps
          this.basemapNodes = [{id: this.config.mapInitialLayer, name: this.config.mapInitialLayer, trans: true,
            isChecked: this.config.mapInitialLayerVisible, nodeType:
          'basemap', opacity: 1, layerAvailable: true}];
          this.basemapArray = [{id: "Basemap", name: "Basemap", nodes: this.basemapNodes, collapsed: true,
            isChecked: this.config.mapInitialLayerVisible}];
          await this.toc.setBasemap(this.config.mapInitialLayer, this.config.mapInitialLayerVisible);
          this.cd.detectChanges();

          if (this.TOCNodeArray)  {
            // Need to set the nestedDataSource to null before reassigning the data due to a bug in refreshing
            //  a nested dataSource.

            this.nestedDataSource.data = null;
            this.nestedDataSource.data = this.TOCNodeArray;
            this.nestedDataSource.data.forEach( (layer) => {
              if (layer.collapsed === false) {
                this.nestedTreeControl.expand(layer);
              }
            });

            this.cd.detectChanges();
          }

          if (this.basemapArray)  {
            // Need to set the nestedDataSource to null before reassigning the data due to a bug in refreshing
            //  a nested dataSource.
            this.nestedBasemapSource.data = null;
            this.nestedBasemapSource.data = this.basemapArray;
            this.nestedBasemapSource.data.forEach( (baseMapLayer) => {
              if (baseMapLayer.collapsed === false) {
                this.nestedTreeControl.expand(baseMapLayer);
              }
            });

            this.cd.detectChanges();
          }
          this.themeHelpInfo = [];
          if (this.config && this.config.Themes && this.config.Themes[this.config.CurrentTheme]) {
            const currThemeObj = this.config.Themes[this.config.CurrentTheme];
            // Check for Help documents
            if (currThemeObj["themeHelpDocuments"] && this.config["appHelpDocuments"]) {
                let httpPrefix = 'https://';
                if (this.config.appHref && this.config.appHref.trim().startsWith('localhost')) {
                  httpPrefix = 'http://';
                }
                currThemeObj["themeHelpDocuments"].forEach((item) => {
                  let helpItem = this.config["appHelpDocuments"][item];
                  if (this.config.appHref && this.config.appHref.trim().startsWith('localhost')) {
                    helpItem.url = httpPrefix + this.config.appHref + '/' + helpItem.url;
                  }
                  this.themeHelpInfo.push(helpItem);
                });
            }
            // Check for theme disclaimer
            if (currThemeObj["themeDisclaimer"] && currThemeObj["themeDisclaimer"].showDisclaimer) {
              if (currThemeObj["themeDisclaimer"].fileName) {
                // Theme disclaimer is in file
                const fileDisclaimerObj = {fileName: currThemeObj["themeDisclaimer"].fileName,
                  showDisclaimer: currThemeObj["themeDisclaimer"].showDisclaimer }
                await this.showDisclaimerFromFile(fileDisclaimerObj);
                // Only show themeDisclaimer once
                currThemeObj["themeDisclaimer"].showDisclaimer = false;
              }
              else {
                if (currThemeObj["themeDisclaimer"].text) {
                  // Theme disclaimer is a text string
                  this.showDisclaimer({"disclaimer": {"message":  currThemeObj["themeDisclaimer"].text}});
                  // Only show themeDisclaimer once
                  currThemeObj["themeDisclaimer"].showDisclaimer = false;
                }
              }
            }
          }
          this.cd.detectChanges();
        } else {
          this.ga.exception('Unable to login', true);
        }
      } else {
        setTimeout(() => {
          this.initializeToC();
        }, 250);
      }
    } catch (error) {
      this.ga.exception(error, true);
    }
  }


  /**
   * Gathers and sorts tags via a web worker
   */
  public gatherTags() {
    if (this.tagList.length === 0 && this.toc.getTagList().length === 0) {
      if (typeof Worker !== 'undefined') {
        const worker = new Worker('../../../web-workers/tags.worker', {type: 'module'});
        worker.onmessage = ({data}) => {
          if (data && data.length > 0 && data[0] === "") {
            data.splice(0,1); // Get rid of blank string in 1st array element if present
          }
          this.tagList = data;
          this.toc.setTagList(data);
        };
        let flatMap = [];
        for (const layer of this.config.tocNodeArray) {
          flatMap = flatMap.concat(this.filterNodeArray(layer));
        }
        worker.postMessage(flatMap);
      }
    } else if (this.toc.getTagList().length !== 0) {
      this.tagList = this.toc.getTagList();
    }
  }


  private countThemesAndHideThemeChangeButton() {
    let themeCount = 0;
    const themes = this.config.Themes;
    for (const key in themes) {
      if ({}.hasOwnProperty.call(themes, key)) {
        themeCount++;
        if (themeCount > 1) {
          this.hideThemeChangeButton = false;
          break;
        }
      }
    }
    if (themeCount <= 1) {
      this.hideThemeChangeButton = true;
    }
  }


  /**
   * Removes the tags from toc node array so they can be passed to a web worker to sort and filter them
   * @param arr: this.config.tocNodeArray layer
   */
  private filterNodeArray(arr) {
    try {
      if (arr.nodes) {
        let tmpArray = [];
        tmpArray.push(arr.name);
        for (const item of arr.nodes) {
          const value = this.filterNodeArray(item);
          if (value) { tmpArray = tmpArray.concat(value); }
        }
        return tmpArray;
      } else {
        if (arr && arr.tags) {
          arr.tags.push(arr.name);
          return arr.tags;
        }
      }
    } catch (error) {
      this.ga.exception(error, false);
    }
  }

  /**
   * User event for the ToC Search input
   * Loops through the node tree array and finds any entries relating to the search
   */
  public filterToC() {
    const newNodeArray = [];
    for (const node of this.config.tocNodeArray) {
      const value = this.filterLoop(node, this.tagFilter.toLowerCase(), node);
      if (value) {
        newNodeArray.push(value);
      }
    }
    this.nestedDataSource.data = null;
    if (newNodeArray.length > 0) {
      this.nestedDataSource.data = newNodeArray;
    }
    this.cd.detectChanges();
  }


  /**
   * Added a function to test enter keys for use with the autocomplete
   * @param event: keypress event
   */
  public filterEnterKey(event) {
    if (event && event.target && event.target.type === 'text') {
      this.filterToC();
      this.cd.detectChanges();
    }
  }

  /**
   * Recursive loop function to search through the node tree array
   * @param arr: Array item to search through
   * @param searchTerm: The search term
   * @param parent: Overall parent object
   */
  private filterLoop(arr, searchTerm, parent?) {
    try {
      if (arr.nodes) {
        if (searchTerm && arr.id.toLowerCase().search(searchTerm) > -1) {
          return arr;
        }
        const tmpParent = cloneDeep(parent);
        tmpParent.nodes = [];
        for (const item of arr.nodes) {
          const value = this.filterLoop(item, searchTerm, item);
          if (value) {
            tmpParent.nodes.push(value);
          }
        }
        if (tmpParent.nodes.length > 0) { return tmpParent; }
      } else {
        if (searchTerm) {
          if (arr.tags && arr.tags.length > 0) {
            for (const tag of arr.tags) {
              if (tag.toLowerCase().search(searchTerm) > -1) {
                return arr;
              }
            }
          }
        }
        return null;
      }
    } catch (error) {
      this.ga.exception(error, false);
    }
  }

  hasNestedChild = (_: number, nodeData: any) => !(!nodeData.nodes);
  private getChildren = (node: any) => node.nodes;

  /**
   * Clears search
   */
  public clearSearch() {
    this.tagFilter = '';
    this.nestedDataSource.data = null;
    this.nestedDataSource.data = this.TOCNodeArray;
    this.cd.detectChanges();
}

  /**
   * TOC: Layer Checkbox clicked
   */
  public async layerCkBoxClicked(event: any, layerElem: AGSLayer) {
    try {
      // Get the latest version of the AGSLayer from the dictionary if it exists.
      const layerSvcLayerID = layerElem.serviceLayerID;
      const currLayerElem = this.toc.agsLayerList.findLayerInVisibleLayerListByID(layerSvcLayerID);
      if (currLayerElem) {
        layerElem = currLayerElem;
      }
      if (layerElem.needsToken && this.config.portalToken) {
        layerElem.token = this.config.portalToken;
        if (layerElem.relateObj && layerElem.relateObj.length > 0) {
          // Add tokens to related table for this secure service
          layerElem.relateObj.forEach( (relatedTable) => {
            relatedTable['token'] = layerElem.token;
          });
        }
      }

      // Test to see if layerElem has a mapLayer object created yet, if not create it
      if (layerElem && !(layerElem.mapImageLayer || layerElem.featureLayer || layerElem.imageryLayer ||
        layerElem.graphicsLayer || layerElem.csvLayer || layerElem.wmsLayer)) {
        // The preloaded tocNodeArray contains AGSLayer objects without the functions. This will add the functions to the object.
        layerElem = new AGSLayer(layerElem);
        layerElem.layerAvailable = true;
        try {
          await layerElem.getMapLayer();  // Get the map object that can be added to the mapview
        } catch (err) {
          layerElem.layerAvailable = false;
        }
      }
      layerElem.isChecked = event.checked;
      const isChecked = layerElem.isChecked;

      if (layerElem.hasOwnProperty('disclaimer')) {
        this.showDisclaimer(layerElem);
      }
      layerElem.checkLayer(isChecked);
      await this.toc.layerCkBoxClicked(event, layerElem);
      layerElem.isInScale = this.isLayerInScale(layerElem);

      this.ga.eventEmitter('layer', 'view-item', layerElem.serviceLayerID, layerElem.isChecked );
      this.cd.detectChanges();
    } catch (error) {
      layerElem.layerAvailable = false;
      this.ga.exception(error, true);
      this.cd.detectChanges();
    }
  }


  public updateOpacity(event){
    // sets the transparency on the layer from the map object
    //console.log('in updateOpacity');
   /*  if (mapLayerObj && mapLayerObj.opacity >= 0) {
      mapLayerObj.opacity = transparency;
    } */

  }

  /**
  * TOC: Basemap Layer Checkbox clicked
  */
 public async basemapClicked(event: any, basemapElem: any) {
   try {
     this.mapRef = this.map.getViewRef();
      if (this.mapRef && this.mapRef.map && this.mapRef.map.basemap && this.mapRef.map.basemap.baseLayers) {
        if (this.mapRef.map.basemap.baseLayers.items && this.mapRef.map.basemap.baseLayers.items[0]) {
          this.mapRef.map.basemap.baseLayers.items[0].visible = basemapElem.isChecked;
        }
        else {
          console.log('In TOC basemapClicked: Basemap missing');
        }
        basemapElem.isChecked = event.checked;
      }

    }
    catch (error) {
      this.ga.exception(error, true);
    }
  }

  /**
   * Shows disclaimer if there is one for the selected node
   * @param node: node passed in from TOC click
   */
  public showDisclaimer(node) {
    if (node.disclaimer && (node.disclaimer.showDisclaimer || node.disclaimer.showDisclaimer === undefined) ) {
      this.dialog.open(DialogComponent, {
        data: node.disclaimer
      });
      node.disclaimer.showDisclaimer = false;
    }
  }

  /**
   * Shows disclaimer from file
   * @param fileNm
   */
  private async showDisclaimerFromFile(fileDisclaimerObj) {
    if (fileDisclaimerObj && fileDisclaimerObj.fileName &&
      (fileDisclaimerObj.showDisclaimer || fileDisclaimerObj.showDisclaimer === undefined)) {
    await fetch (fileDisclaimerObj.fileName).then(
      res => res.text()).then(
        tempData => {
          this.htmlFileString = this.sanitizer.sanitize(SecurityContext.HTML,this.sanitizer.bypassSecurityTrustHtml(tempData));
          this.showDisclaimer({"disclaimer": {"message": this.htmlFileString}});
      });
    };
  }

  /**
   * Determines whether layer in scale is
   * @param node
   * @returns
   */
  public isLayerInScale(node: AGSLayer) {
    this.mapScale = this.toc.getMapScale();
    node.isInScale = (node.minScale === undefined || node.minScale === 0 || node.minScale >= this.mapScale)
      && (node.maxScale === undefined || node.maxScale === 0 || node.maxScale <= this.mapScale);
    return node.isInScale;
  }

  /**
   * Determines whether layer is available
   * @param node
   * @returns
   */
  public isLayerAvailable(node:AGSLayer) {
    return node.layerAvailable;
  }

  /**
   * TOC: Parent Checkbox clicked
   */
  public parentCkBoxClicked(event, node: any) {
    try {
      node.isChecked = event.checked;
      this.toc.parentCkBoxClicked(node);
      // Check for group dependent folders. These are parent nodes with a groupDependency property. Only
      // 1 folder within the group Dependent folders, can be turned on at a time.
      const currState = this;
      if (node.isChecked && node.groupDependency) {
        const groupDepName = node.groupDependency;
        let nodeMatches = [];
        this.TOCNodeArray.forEach((nodeEvent) => {
          const e: any = nodeEvent;
          nodeMatches = nodeMatches.concat(e.nodes.filter((c) => {
            if (c.id !== node.id && c.isChecked && c.groupDependency && c.groupDependency === groupDepName) {
              c.isChecked = false;
              currState.toc.parentCkBoxClicked(c);
              return (c);
            }
          }));
        });
      }
      this.ga.eventEmitter('layer', 'view-item', node.serviceLayerID, node.isChecked );
      this.cd.detectChanges();
    } catch (error) {
      this.ga.exception(error, true);
    }
  }

  /**
   * Trackby function to optimize changes to the material tree object
   * @param index: index item
   */
  public trackBy(index) {
    return index;
  }

  /**
   * Handles user triggered event when a theme item is clicked
   * Updates the hash link with the theme item
   * @param item: String item that was clicked on
   */
  public async themeClick(item) {
    this.clearSearch();
    this.cd.detectChanges();
    try {
      if (item) {
        //console.log('***in toc themeClick: ' + item + ' currentTheme: ' + this.config.CurrentTheme +
        //' chosenThemeName: ' + this.toc.getTheme(item));
        const chosenThemeName = this.toc.getTheme(item);
        if (chosenThemeName && this.config) {
          this.loading = true;
          this.toc.firstRunFlag = false;
          this.toc.removeAllLayers(true);
          this.config.CurrentTheme = item;
          this.currentTheme = this.config.CurrentTheme;
          this.toc.currentTheme = this.config.CurrentTheme;
          //console.log('toc-comp call initService: ' + this.config.CurrentTheme);
          await this.initService.init(true);
          //console.log('toc-comp aft call initService: ' + this.config.CurrentTheme);
          this.initializeToC();
          //console.log('toc-comp aft initializeTOC call themeChange: ' + this.config.CurrentTheme);
          this.toc.themeChange(this.config.CurrentTheme);
          this.loading = false;
          this.cd.detectChanges();

          /* if (this.config && this.config['maintainThemeMapExtent'] && this.config['maintainThemeMapExtent'] === true) {
            const currMapExt = this.toc.getMapExtentCoordString(['xmin','xmax','ymin','ymax']);
            if (currMapExt && currMapExt.length > 0) {
              url = url + '?currMapExt=' + currMapExt;
            }
          } */
          /* this.location.go(url);
          window.location.reload(); */
          //this.cd.detectChanges();
        }
      }
    } catch (error) {
      this.ga.exception(error, true);
    }
  }

  public async themeClickOrig(item) {
    try {
      if (item) {
        const chosenThemeName = this.toc.getTheme(item);
        if (chosenThemeName && this.config) {
          let url = this.router.createUrlTree([], {relativeTo: this.route}).toString();
          url = url + '#' + chosenThemeName;
          /* if (this.config && this.config['maintainThemeMapExtent'] && this.config['maintainThemeMapExtent'] === true) {
            const currMapExt = this.toc.getMapExtentCoordString(['xmin','xmax','ymin','ymax']);
            if (currMapExt && currMapExt.length > 0) {
              url = url + '?currMapExt=' + currMapExt;
            }
          } */
          this.location.go(url);
          window.location.reload();
          //this.cd.detectChanges();
        }
      }
    } catch (error) {
      this.ga.exception(error, true);
    }
  }

/**
 * Changelog click
 */
public changelogClick() {
    this.dialog.open(ChangelogDialogComponent, {
      data: this.config.changelog
    });
  }
}
